import React from 'react'
import TDSTable from '../../components/TDS reports/TDSTable'
import './tdsreports.css'
import CompanyDashboard from '../../components/companies/CompanyDashboard'
const TDSTableMain = () => {
  return (
    <div>
      <TDSTable/>
    </div>
  )
}

export default TDSTableMain
